module.exports = __webpack_public_path__ + "media/images/athletes/3514-a22d18582a7ba26f3646f21b6885d98d.png";